module.exports = __webpack_public_path__ + "static/media/professional.b6c3495f.png";